export default __webpack_public_path__ + "maps-examples-runtime-animate-line-thumbnail-480-bdd1167741e414a8f321713b88433cee.webp";